import type { ReactNode } from 'react';
import { StyleSheet } from 'react-native';
import Animated from 'react-native-reanimated';
import useFadeInStyle from '@/hooks/useFadeInStyle';

type FadeInContentProps = {
  fetching?: boolean;
  children: ReactNode;
  animateOnMount?: boolean;
  delay?: number;
  flex?: boolean;
  testID?: string;
};

const style = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default function FadeInContent({
  fetching,
  children,
  animateOnMount = false,
  delay = 0,
  flex = true,
  testID,
}: FadeInContentProps) {
  const animatedStyle = useFadeInStyle(fetching, delay, animateOnMount);

  return (
    <Animated.View
      style={[flex && style.container, animatedStyle]}
      testID={testID}
    >
      {children}
    </Animated.View>
  );
}
